import { noticeError } from './newrelic';

export default async function getToken(videoApiURL: string): Promise<string | null> {
  try {
    const response = await fetch(`${videoApiURL}/graphql`, {
      method: 'POST',
      headers: window.isProduction ? {} : { 'x-client-details': 'qa' },
      body: JSON.stringify({
        query: `{ drmToken(drmProvider: JWP) { token expiration } }`,
        variables: {},
      }),
    });
    const { data, errors } = await response.json();

    if (errors?.length || !data?.drmToken) {
      const [error] = errors || [];
      noticeError(new Error('Failed to fetch token'), { graphql_error: error.message });
      return null;
    }

    return data.drmToken.token;
  } catch (error) {
    console.error(error);
    noticeError(new Error('Failed to fetch token'), { graphql_error: (error as any)?.message });
  }
  return null;
}
